import React,{Component} from 'react'
import Link from 'react-router'
import ModalHeader from 'CONFIG/component/modalHeader'
import ModalFooter from 'CONFIG/component/modalFooter'
import {language} from 'UTIL/common'

export default class Modal extends Component{
     render(){
        return (
            <div className="modal fade" id={this.props.modal.id} tabIndex="-1" role="dialog"
					 aria-labelledby="myModalLabel" aria-hidden="true" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <ModalHeader title = {this.props.modal.title} />
                        <div className="modal-body">
                            {language()[this.props.modal.text]}
                        </div>
                        <ModalFooter modClick={this.props.modalSure}/>
                    </div>
                </div>
            </div>
        )
     }
}
//Modal
//<Modal modal={"id":id,"title":title,"text":text}  modalSure= {this.methods}/>


// WEBPACK FOOTER //
// ./modules/component/modal.js